import { render, staticRenderFns } from "./CardEconomy.vue?vue&type=template&id=5ecaa7f1&"
import script from "./CardEconomy.vue?vue&type=script&lang=js&"
export * from "./CardEconomy.vue?vue&type=script&lang=js&"
import style0 from "./CardEconomy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports